import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const CompaniaCell = ({ cellInfo, checked }) => {
  return (
    <Field name='companias'>
      {({ field }) => (
        <Form.Checkbox {...field} id={`check-${cellInfo.razonSocial}`} label={cellInfo.razonSocial} value={cellInfo._id} checked={checked} />
      )}
    </Field>
  )
}

export default React.memo(CompaniaCell)
